import { render, staticRenderFns } from "./notice-modal.vue?vue&type=template&id=9280ad4e&scoped=true"
import script from "./notice-modal.vue?vue&type=script&lang=js"
export * from "./notice-modal.vue?vue&type=script&lang=js"
import style0 from "./notice-modal.vue?vue&type=style&index=0&id=9280ad4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9280ad4e",
  null
  
)

export default component.exports